import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, fmtErr, fmtDate } from "../api";
import { inputCls } from "../components";

const ENTITIES = ["all", "auth", "project", "page", "media", "job", "user"];

const ActivityLog = () => {
  const [items, setItems] = useState(null);
  const [entity, setEntity] = useState("all");

  useEffect(() => {
    adminApi.get("/audit").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e)));
  }, []);

  const filtered = (items || []).filter((a) => entity === "all" || a.entity === entity);

  return (
    <div data-testid="admin-activity-page">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Activity Log</h1>
          <p className="mt-1 text-sm text-slate-500">Every login and content change — who, what, when.</p>
        </div>
        <select className={`${inputCls} !w-48`} value={entity} onChange={(e) => setEntity(e.target.value)} data-testid="activity-filter">
          {ENTITIES.map((e) => <option key={e} value={e}>{e === "all" ? "All activity" : `${e}s`}</option>)}
        </select>
      </div>

      <div className="mt-6 bg-white border border-slate-200 rounded-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead>
            <tr className="border-b border-slate-200 text-left">
              {["Date & Time", "User", "Role", "Action", "Item", "Detail"].map((h) => (
                <th key={h} className="px-5 py-3 text-[10px] font-bold uppercase tracking-widest text-slate-400">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items === null ? (
              <tr><td colSpan={6} className="px-5 py-10 text-center text-slate-400">Loading…</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={6} className="px-5 py-10 text-center text-slate-400">No activity recorded.</td></tr>
            ) : (
              filtered.map((a) => (
                <tr key={a.id} className="border-b border-slate-100" data-testid={`audit-row-${a.id}`}>
                  <td className="px-5 py-3 text-xs text-slate-500 whitespace-nowrap">{fmtDate(a.at)}</td>
                  <td className="px-5 py-3 font-semibold text-slate-800">{a.user_email}</td>
                  <td className="px-5 py-3 text-xs text-slate-500 uppercase">{a.role}</td>
                  <td className="px-5 py-3">
                    <span className={`text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-sm ${
                      a.action.includes("delete") || a.action.includes("failed") ? "bg-red-50 text-red-700"
                      : a.action.includes("publish") ? "bg-emerald-50 text-emerald-700"
                      : "bg-slate-100 text-slate-600"
                    }`}>{a.action.replace(/_/g, " ")}</span>
                  </td>
                  <td className="px-5 py-3 text-xs text-slate-500 font-mono-tech">{a.entity_id || "—"}</td>
                  <td className="px-5 py-3 text-xs text-slate-600 max-w-[220px] truncate">{a.detail || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActivityLog;
